import { IDP_CALLBACK_PATH } from "./constants";

export interface UrlParams {
  email?: string;
  screen_hint?: string;
  token?: string;
  prompt?: string;
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  utm_term?: string;
  utm_content?: string;
  utm_referrer?: string;
  gclid?: string;
  fbclid?: string;
  msclkid?: string;
  li_fat_id?: string;
  _gl?: string;
  ext_gaClientId?: string;
  ext_gaSessionId?: string;
  ext_anonymousId?: string;
  [key: string]: string | undefined;
}

/**
 * Extracts URL parameters for login flows from URLSearchParams
 */
export const extractUrlParameters = (urlParams: URLSearchParams): UrlParams => {
  const keys = [
    "email",
    "screen_hint",
    "token",
    "prompt",
    "_gl",
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_term",
    "utm_content",
    "utm_referrer",
    "gclid",
    "fbclid",
    "msclkid",
    "li_fat_id",
    "ext-gaClientId",
    "ext-gaSessionId",
    "ext-anonymousId",
  ];

  return keys
    .map((key) => [key, urlParams.get(key)])
    .filter(([, value]) => value !== "" && value !== null)
    .reduce<Record<string, string>>((acc, [key, value]) => {
      // @ts-ignore The null check for key is unnecessary since the key comes from the predefined keys array which contains only strings. This condition will never be true.
      acc[key.replace(/-/g, "_")] = value as string;
      return acc;
    }, {});
};

export const buildCallbackUrl = (baseUrl: string, params: UrlParams) => {
  const redirect_uri = `${baseUrl}${IDP_CALLBACK_PATH}`;
  const redirect_url = new URL(redirect_uri);
  const keys = [
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_term",
    "utm_content",
    "utm_referrer",
    "gclid",
    "fbclid",
    "msclkid",
    "li_fat_id",
  ];
  keys
    .filter((key) => params[key] != null) // filters out null or undefined values
    .forEach((key) => redirect_url.searchParams.set(key, <string>params[key]));
  return redirect_url.toString();
};
